var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"notification"}},[(_vm.show)?_c('section',{staticClass:"notification",class:{
      'notification--info': _vm.info,
      'notification--warning': _vm.warning,
      'notification--success': _vm.success
    }},[_c('div',{staticClass:"notification__content"},[_vm._t("default")],2),_vm._v(" "),_c('close-button',{staticClass:"notification__close-button",nativeOn:{"click":function($event){return _vm.dismiss.apply(null, arguments)}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }